// extracted by mini-css-extract-plugin
module.exports = {"noPage":"no-page_noPage__SoVFn","title":"no-page_title__206T1"};